import { DI } from '@microsoft/fast-foundation';
/**
 * The default implementation for the MetaCache interface.
 * @public
 */
export class DefaultMetaCache {
    constructor() {
        this.cachedMetadata = new Map();
        this.cachedJsonSchema = new Map();
    }
    getMetadataFor(resourceName) {
        return this.cachedMetadata.get(resourceName);
    }
    getJsonSchemaFor(resourceName) {
        return this.cachedJsonSchema.get(resourceName);
    }
    hasMetadataFor(resourceName) {
        return this.cachedMetadata.has(resourceName);
    }
    hasJsonSchemaFor(resourceName) {
        return this.cachedJsonSchema.has(resourceName);
    }
    setMetadataFor(resourceName, metadata) {
        this.cachedMetadata.set(resourceName, metadata);
    }
    setJsonSchemaFor(resourceName, schemaResponse) {
        this.cachedJsonSchema.set(resourceName, schemaResponse);
    }
}
/**
 * The DI token for the MetaCache interface.
 * @internal
 */
export const MetaCache = DI.createInterface((x) => x.singleton(DefaultMetaCache));
